import React, { Component } from "react";
import PropTypes from "prop-types";

class Controls extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false,
		};
	}

	toggleVisibility = e => {
		e.preventDefault();
		const { visible } = this.state;
		this.setState({
			visible: !visible,
		});
	};

	render() {
		const { visible } = this.state;
		const { crud, id } = this.props;

		const { deleteItem, duplicateItem, editItem } = crud;

		const fireAction = (e, type, id) => {
			e.preventDefault();
			switch (type) {
				case "EDIT":
					editItem(id);
					break;
				case "DUPLICATE":
					duplicateItem(id);
					break;
				case "DELETE":
					deleteItem(id);
					break;
				default:
					break;
			}
		};

		return (
			<div className={`controls ${visible ? "" : "hide-controls"}`}>
				<button onClick={e => this.toggleVisibility(e)}>
					<i className="fal fa-ellipsis-v"> </i>
				</button>
				<button onClick={e => fireAction(e, "EDIT", id)}>
					<i className="fal fa-edit"> </i>
				</button>
				<button onClick={e => fireAction(e, "DUPLICATE", id)}>
					<i className="fal fa-clone"></i>
				</button>
				<button onClick={e => fireAction(e, "DELETE", id)}>
					<i className="fal fa-trash"></i>
				</button>
			</div>
		);
	}
}

Controls.propTypes = {
	crud: PropTypes.object.isRequired,
	id: PropTypes.string.isRequired,
};

export default Controls;
